<template>
  <div>
    <b-loading :active="loading" />
    <b-table
      :data="orders"
      :default-sort="[sortField, sortOrder]"
      :mobile-cards="false"
      backend-sorting
      hoverable
      scrollable
      @sort="onSort"
    >
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="idx"
        header-class="is-size-7 px-4 py-2"
        label="No."
        width="60px"
        v-slot="props"
      >
        <span :class="getCancelledColor(props.row)">
          {{ props.index + 1 + (currentPage - 1) * currentPerPage }}.
        </span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="id"
        header-class="is-size-7 px-4 py-2"
        label="訂購ID"
        width="80px"
        v-slot="props"
      >
        <span :class="getCancelledColor(props.row)" class="font-small">{{ props.row.id }}</span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="scheduleId"
        header-class="is-size-7 px-4 py-2"
        label="例行性ID"
        width="80px"
        v-slot="props"
      >
        <span
          :class="getCancelledColor(props.row)"
          class="font-small"
        >{{
          props.row.scheduleId
        }}</span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="name"
        header-class="is-size-7 px-4 py-2"
        label="訂購名稱"
        width="80px"
        v-slot="props"
      >
        <span :class="getCancelledColor(props.row)" class="font-small">{{ props.row.name }}</span>
      </b-table-column>
      <b-table-column
        :label="dateType === 'start' ? '開放訂購日' : '開放領取日'"
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="start"
        header-class="is-size-7 px-4 py-2"
        sortable
        v-slot="props"
        width="104px"
      >
        <span
          :class="getCancelledColor(props.row)"
          class="font-small"
        >{{
          getTimeByType(props.row)
        }}</span>
      </b-table-column>
      <b-table-column
        :cell-class="column.cellClass"
        :centered="column.centered"
        :field="column.field"
        :header-class="column.headerClass || 'is-size-7 py-2'"
        :key="`order-column-${column.field}`"
        :label="column.label"
        :numeric="column.numeric"
        :th-attrs="columnThAttrs"
        :width="column.width"
        v-for="column in columns"
        v-slot="props"
      >
        <b-taglist v-if="column.isTag">
          <span
            v-for="tag in props.row[column.field]"
            :key="`tag-${tag}`"
            class="
              bg-blue-50
              border
              border-blue-100
              last:mr-1
              leading-[22px]
              mr-1
              px-[10px]
              py-[1px]
              rounded-full
              whitespace-nowrap
            "
          >
            {{ tag }}
          </span>
        </b-taglist>
        <span v-else-if="column.field === 'status'">
          <span :class="groupBuyingStatusColor(props.row)">
            {{ getStatusDescription(props.row) }}
          </span>
        </span>
        <span v-else-if="column.field === 'receivingCount'">
          <span :class="getCancelledColor(props.row)"
          >{{ props.row.received | commaFormat }}</span>/<span
            :class="getUnreceivedColor(props.row)"
          >{{ props.row.unreceived | commaFormat }}</span>
        </span>
        <span v-else>
          <span
            :class="getCancelledColor(props.row)"
            class="font-small"
          >{{
            props.row[column.field]
          }}</span>
        </span>
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="px-4"
        field="action"
        label="操作"
        width="28px"
        header-class="is-size-7 px-4 py-2"
        v-slot="props"
      >
        <span class="cursor-pointer font-small hover:text-blue-500 text-blue-400"
          @click.stop.prevent="toDetail(props.row.id)">
            詳情
        </span>
      </b-table-column>

      <template #empty>
        <div
          v-if="!loading"
          class="
            is-align-items-center
            is-flex
            is-flex-direction-column
            is-justify-content-center
            my-5
            statistics-list__empty
          "
        >
          <span v-if="!hasDateRange" class="text-[#4F5865]">請於左上方選擇資料日期範圍</span>
          <template v-else>
            <img
              alt="Empty Statistics Image"
              class="statistics-list__empty--image"
              src="@/assets/images/empty-statistics-image.svg"
              width="376px"
            />
            <span>尚未有統計資料喔</span>
          </template>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import GroupBuyingsList from './GroupBuyingsList';

export default GroupBuyingsList;
</script>

<style lang="scss" scoped>
@import 'GroupBuyingsList';
</style>
